import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import "./box.css";
// or scss:
// import 'react-image-crop/src/ReactCrop.scss'

const CropImageDialog = ({
  cropModal,
  setCropModal,
  imagedata,
  setNewImage,
  setFieldValue,
}) => {
  const [image, setImage] = useState(imagedata.imageurl);
  const [cropData, setCropData] = useState("");
  const [cropper, setCropper] = useState();

  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      setCropData(cropper.getCroppedCanvas().toDataURL());
      let blogData = dataURItoBlob(cropper.getCroppedCanvas().toDataURL());
      setNewImage({
        imageurl: cropper.getCroppedCanvas().toDataURL(),
        image: blogData,
      });
      setFieldValue("retailer_logo", blogData);
      setCropModal(false);
    }
  };

  const dataURItoBlob = (dataURI) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);
    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  };



  return (
    <Modal
      show={cropModal}
      onHide={() => setCropModal(false)}
      animation={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Crop Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {(cropData && (
          <img
            style={{ width: "100%", height: "100%" }}
            src={cropData}
            alt="cropped"
          />
        )) || (
          <Cropper
            style={{ height: 300, width: "100%" }}
            zoomTo={0.5}
            initialAspectRatio={1}
            preview=".img-preview"
            src={image}
            circularCrop={true}
            viewMode={0.2}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            background={false}
            responsive={true}
            autoCropArea={1}
            checkOrientation={false}
            onInitialized={(instance) => {
              setCropper(instance);
            }}
            guides={true}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={() => setCropModal(false)}>
          Cancel
        </Button>
        <Button variant="danger" onClick={getCropData}>
          Crop
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CropImageDialog;
